import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as styles from './publift-ad.module.scss';

const PubliftAd = ({ adId, mobileHeight = '100', desktopHeight = '90' }) => {
    const mobileClass = styles[`mobile${mobileHeight}`];
    const desktopClass = styles[`desktop${desktopHeight}`];

    useEffect( () => {
        const fusetag = window.fusetag || ( window.fusetag = { que: [] } );
        fusetag.que.push( function() {
            fusetag.registerZone( adId );
        } );
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return <div id={ adId } data-fuse={ adId } className={`${styles.publiftAd} ${mobileClass} ${desktopClass}`}></div>;
};

PubliftAd.propTypes = {
    adId: PropTypes.string.isRequired,
    mobileHeight: PropTypes.string,
    desktopHeight: PropTypes.string,
};

export default PubliftAd;
